var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6DAA3F05-6DFB-4D86-A74A-2B41EFA3D157") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP---Clinician",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "REGISTER",
    transform: "translate(-33.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(33.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.411533317,-6.74698855e-06 C9.98176311,0.110194917 17.7058824,7.90246998 17.7058824,17.4988098 C17.7058824,27.1637929 9.87086547,34.9988098 0.205882353,34.9988098 L0.410882353,34.996 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#FFFFFF",
    transform: "translate(8.955882, 17.499405) scale(-1, 1) translate(-8.955882, -17.499405) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4997686,0.00118349696 C27.0699984,0.111385161 34.7941176,7.90366022 34.7941176,17.5 C34.7941176,27.1649831 26.9591008,35 17.2941176,35 L17.4991176,34.9971902 Z",
    id: "Combined-Shape",
    fill: "#36C2B4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.970588, 6.176471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.205882, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2322103,0 L11.2322105,0.547912731 C5.33143579,0.547912731 0.547912731,5.33143579 0.547912731,11.2322105 C0.547912731,17.1329852 5.33143579,21.9165083 11.2322105,21.9165083 L11.2322105,21.9165083 L11.2322103,22.4644205 C5.02883183,22.4644205 8.4847162e-14,17.4355887 8.4847162e-14,11.2322103 C8.4847162e-14,5.02883183 5.02883183,0 11.2322103,0 L11.2322103,0 Z",
    id: "Combined-Shape",
    fill: "#36C2B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2322103,-1.4628821e-15 C17.4355887,-1.4628821e-15 22.4644205,5.02883183 22.4644205,11.2322103 C22.4644205,17.4355887 17.4355887,22.4644205 11.2322103,22.4644205 L11.2322103,22.4644205 L11.2322105,21.9165083 C17.1329852,21.9165083 21.9165083,17.1329852 21.9165083,11.2322105 C21.9165083,5.33143579 17.1329852,0.547912731 11.2322105,0.547912731 L11.2322105,0.547912731 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2be818743a10f23cc425f3d2419d4900.svg";
export { ForwardRef as ReactComponent };